import i18n from 'app/i18/i18'

import { CountriesPhone } from 'shared/constants/countries'

import { PhoneInputValue } from '../model'

export const customValidatePhone = (data?: PhoneInputValue) => {
  if (!data) return false

  const phoneByCountry =
    CountriesPhone?.[data?.code as keyof typeof CountriesPhone]

  if (phoneByCountry?.length === data?.phone?.length) {
    return true
  } else {
    return i18n.t('please_input_valid_phone_number')
  }
}
